export default {
  data() {
    const tableModel = [
      { width: 180, slotName: 'bpmId', label: 'Trans#' },
      { width: 200, prop: 'companyName', label: 'Customer Name' },
      { width: 120, prop: 'sourceStr', label: 'Source' },
      { width: 120, prop: 'approver', label: 'Owned By' },
      { width: 200, prop: 'statusStr', label: 'Status' },
      { width: 200, prop: 'approveDate', label: 'Last Modified Date' },
      { width: 200, prop: 'typeStr', label: 'Credit Category' },
    ]
    return {
      tableModel,
    }
  },
}
